module.exports = __webpack_public_path__ + "images/tr_wework/ic-processing@2x-52c85e2945f9d96c6bf09f853a5b7717.png";